'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoMusicNote = function IoMusicNote(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.3 2.5c0.9 0 1.7 0.7 1.7 1.6v23.7s-0.2 3.4-0.9 4.3c-0.7 1.2-2 1.7-3.4 1.7h-2.9c-2.2 0-4.1-1.6-4.1-3.8s1.9-3.7 4.1-3.7h4.7v-15l-16.2 2.9v18.1c0 0.7-0.3 2.2-1.1 3.2 0 0.2-0.1 0.3-0.2 0.4 0 0.1-0.1 0.1-0.2 0.2-0.7 0.9-1.8 1.4-2.9 1.4h-2.9c-2.2 0-4-1.6-4-3.7s1.8-3.8 4-3.8h4.8v-22.3c0-1.1 1-2.2 2.1-2.5l17-2.6s0.2-0.1 0.4-0.1z' })
        )
    );
};

exports.default = IoMusicNote;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/music-note.js
// module id = 2361
// module chunks = 0